import React, { useState } from 'react';
import axios from 'axios'
import {
    Button,
    Form,
    FormGroup,
    Label,
    Input,
    Alert,
    Card,
    CardBody
} from 'reactstrap'
import { Navigate, useParams } from 'react-router-dom';
import { tokenConfig } from '../utils/apiConfig';

const ResetPassword = () => {
    const { token } = useParams()
    const [password, setPassword] = useState('')
    const [password2, setPassword2] = useState('')
    const [errorMessage, setErrorMessage] = useState('')
    const [successMessage, setSuccessMessage] = useState('') 
    const [redirect, setRedirect] = useState(false)
    const [loading, setLoading] = useState(false)
    
    const onSubmit = async e => {
        e.preventDefault();
        //Clear errors
        setErrorMessage('')
        setSuccessMessage('')
        setLoading(true)

        // create a user object
        const newPassword = {
            token,
            password,
            password2
        }
        const config = tokenConfig()
        config.headers['x-auth-token'] = token
        await axios.post('/api/auth/resetPassword',newPassword, config)
        .then(res => {
            setSuccessMessage(res.data.message)
            setTimeout(() => {
                setRedirect(true)
            }, 3000);
        })
        .catch(err => {
            setErrorMessage(err.response.data.message)
            setLoading(false)
        })
    }

    if(redirect)  return  <Navigate replace to='/'/>
    return (
        <div className='auth-page-shell'>
            <Card className='auth-card'>
                <div className='auth-card__header'>
                    <span className='eyebrow'>New Password</span>
                    <h1 className='section-title' style={{ fontSize: '1.8rem' }}>Set your new password</h1>
                    <p className='section-lead'>Choose a new password for your FoBK account. Once saved, you will be redirected back to the home page.</p>
                </div>
                <CardBody className='auth-card__body'>
                    { errorMessage? <Alert color="danger">{ errorMessage }</Alert>: null }
                    { successMessage? <Alert color="success">{ successMessage }</Alert>: null }
                    <Form onSubmit={onSubmit}>
                        <FormGroup>
                            <Label for = "password" >Password</Label>
                            <Input 
                                type = "password"
                                name = "password"
                                id = "password"
                                onChange = {e => setPassword(e.target.value)}
                                required
                            />
                        </FormGroup>
                        <FormGroup>
                            <Label for = "password2" >Confirm Password</Label>
                            <Input 
                                type = "password"
                                name = "password2"
                                id = "password2"
                                onChange = {e => setPassword2(e.target.value)}
                                required
                            />
                        </FormGroup>
                        <Button
                            color= "dark"
                            className='w-100 mt-4'
                            style = {{cursor:loading&&'progress'}}
                            disabled={loading}
                            block
                        >
                            Reset Password
                        </Button>
                    </Form>
                </CardBody>
            </Card>
        </div>
    )
}

export default ResetPassword
